import { render, staticRenderFns } from "./SalesInvoiceExtractAll.vue?vue&type=template&id=678de4a5&scoped=true"
import script from "./SalesInvoiceExtractAll.vue?vue&type=script&lang=js"
export * from "./SalesInvoiceExtractAll.vue?vue&type=script&lang=js"
import style0 from "./SalesInvoiceExtractAll.vue?vue&type=style&index=0&id=678de4a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678de4a5",
  null
  
)

export default component.exports